/* global window document */

import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout } from 'common/components/layout';
import { getProduct } from 'redux/products/actions';
import { getProductBySlug } from 'redux/products/reducers';

import Template from './components/ProductDetailTemplate';
import { drilldownTemplate } from './defaultTemplates';

class ProductDrilldown extends Component {
  componentDidMount() {
    const { props } = this;
    const { slug } = props.match.params;
    props.getProduct(slug);
    try {
      window.scrollTo({ top: 0 });
    } catch {
      // Not all browsers have scrollTo
    }
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('c7-layout__product-detail');
  }

  componentWillUnmount() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('c7-layout__product-detail');
  }

  render() {
    const { settings, product, productTemplate, productReducer } = this.props;
    if (!settings.data || (!product && productReducer.isFetching)) {
      return (
        <Layout title="" loading>
          &nbsp;
        </Layout>
      );
    }
    if (!product && !productReducer.isFetching) {
      return (
        <Layout title="" loading>
          Product not found
        </Layout>
      );
    }
    let newTemplate = drilldownTemplate;
    if (product.productTemplateId) {
      if (
        productTemplate.data &&
        productTemplate.data[product.productTemplateId] &&
        productTemplate.data[product.productTemplateId].content
      ) {
        newTemplate =
          productTemplate.data &&
          productTemplate.data[product.productTemplateId] &&
          productTemplate.data[product.productTemplateId].content;
      }
    } else if (
      productTemplate.data &&
      productTemplate.data.default &&
      productTemplate.data.default.content
    ) {
      newTemplate = productTemplate.data.default.content;
    }
    return (
      <Layout title={product.seo.title} description={product.seo.description}>
        <Template
          product={product}
          template={newTemplate}
          settings={settings}
        />
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  product: getProductBySlug(state.product, ownProps.match.params.slug),
  productReducer: state.product,
  productTemplate: state.productTemplate,
  settings: state.setting
});

export default connect(mapStateToProps, {
  getProduct
})(ProductDrilldown);
